// Header Menu navigation with jQuery
jQuery(function ($) {
	const $navBar = $('.nav-bar');
	if ($navBar.length === 0) return;

	let lastScrollTop = 0;
	let ticking = false;
	const scrollThreshold = 100; // Number of pixels to scroll before hiding starts

	function updateNavBarVisibility() {
		const currentScroll = $(window).scrollTop();

		// Only hide/show after scrolling past the threshold
		if (currentScroll <= scrollThreshold) {
			// Always show when near the top
			$navBar.removeClass('nav-bar--hidden');
		} else if (currentScroll > lastScrollTop) {
			// Scrolling down - hide the navbar
			$navBar.addClass('nav-bar--hidden');
		} else {
			// Scrolling up - show the navbar
			$navBar.removeClass('nav-bar--hidden');
		}

		lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			requestAnimationFrame(updateNavBarVisibility);
			ticking = true;
		}
	}

	$(window).on('scroll', onScroll);
});
